<template>
  <div v-if="currentChecklist">
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="row d-flex justify-content-md-center">
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="nom"
                        >Nom de la checklist
                        <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('nom') }"
                        id="nom"
                        v-model="form.nom"
                        type="text"
                        placeholder="Nom de la checklist"
                        maxlength="100"
                        required
                      />
                      <has-error :form="form" field="nom"></has-error>
                    </div>
                  </div>
                  <div class="col-md-2 col-lg-1 mt-3 pt-1">
                    <switches
                      text-enabled="Statut actif"
                      text-disabled="Statut inactif"
                      v-model="form.statut"
                      type-bold="true"
                      color="custom-primary"
                      class="ml-1 mb-0 font-size-17"
                    ></switches>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Enregistrer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL from '@/http/rh/entretien/checklist';
import Form from 'vform';
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      form: new Form({
        nom: '',
        statut: false,
      }),
    };
  },
  computed: {
    ...mapGetters('checklist', ['currentChecklist']),
  },
  methods: {
    ...mapActions('checklist', ['setCurrentChecklist']),
    async refresh() {
      this.setCurrentChecklist(null);

      await window.axios
        .get(URL.CHECKLIST + '/' + this.$route.params.id)
        .then((resp) => {
          this.setCurrentChecklist(resp.data.checklist);
        })
        .catch();

      await this.init();
    },
    init() {
      Object.assign(this.form, this.currentChecklist);
    },
    submit() {
      this.form
        .put(URL.CHECKLIST + '/' + this.$route.params.id)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.refresh();
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
